import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import { Box, Card } from '@mui/material';

// ----------------------------------------------------------------------

const Page = forwardRef(({ children, title = '', meta, sx = {}, ...other }, ref) => {
  return (
    <>
      <Helmet>
        <title>{`${title} | Delivery do Foguim`}</title>
        {meta}
      </Helmet>

      <Box ref={ref} {...other} sx={{ p: 2, ...sx }}>
        <Card sx={{ p: 2, borderRadius: 3 }}>
          {children}
        </Card>
      </Box>
    </>
  )
});

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  meta: PropTypes.node,
};

export default Page;